<template>
  <tr>
    <template v-for="column in filterHeaders()">
      <td
        v-if="column.key === 'icons'"
        :key="column.key"
        qaid="shipment.grid.row.notes"
        class="b2b-grid__cell lg:table-cell"
        :class="[
          {
            'whitespace-nowrap': column.key === 'icons',
          },
          column.cssClasses,
        ]"
      >
        <div class="flex flex-nowrap">
          <grid-icon
            v-if="item.isSplitWarehouse"
            :data="{
              value: 'call_split',
            }"
          />
          <grid-note
            v-show="item.lineComment"
            :row-id="item.id"
            :data="{
              value: 'insert_drive_file',
              content: item.lineComment,
              editable: notesEditable,
              cssClass: 'ml-1',
            }"
          />
        </div>
      </td>
      <grid-cell
        v-else
        :key="column.key"
        :cell-key="column.key"
        :label="column.label"
        :qaid="`order-detail-item-${column.key}`"
        :value="column.key !== 'lineStatus' ? itemData[column.key] : null"
        :classes="[
          {
            'whitespace-nowrap': column.key === 'lineStatus' || column.key === 'icons',
            'w-1': column.key !== 'itemName',
          },
          column.cssClasses,
        ]"
      >
        <pdl-label
          v-if="column.key === 'lineStatus'"
          class="align-self-top mr-0"
          :kind="calculateLabelKind(item[column.key])"
        >
          <span v-html="bp(item[column.key])" />
        </pdl-label>
      </grid-cell>
    </template>
  </tr>
</template>

<script>
import {mapGetters} from 'vuex';
import {PdlLabel} from '@pedal/pdl-label';

export default {
  components: {
    PdlLabel,
  },

  inject: ['container', 'headers'],
  props: {
    item: {
      type: Object,
      default: () => {},
    },
    selectable: {
      type: Boolean,
      default: true,
    },
    baseProperties: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      notesEditable: false,
    };
  },
  computed: {
    ...mapGetters('backend', ['consumerFriendlyMode']),
    itemData() {
      const data = this.item;
      data['unitPrice'] = data.basePrice.formattedValue;
      data['lineSubtotal'] = data.totalPrice.formattedValue;
      return data;
    },
  },
  methods: {
    filterHeaders() {
      let consumerFriendlyMode = this.consumerFriendlyMode;
      return this.headers.filter((header) => {
        if (consumerFriendlyMode && (header.key == 'unitPrice' || header.key == 'lineSubtotal')) {
          return false;
        } else {
          return true;
        }
      });
    },
    calculateLabelKind(status) {
      let labelKind;

      switch (status) {
        case 'CANCELLED':
          labelKind = 'critical';
          break;
        case 'INVOICED':
          labelKind = 'prominent';
          break;
        case 'IN_WAREHOUSE':
          labelKind = 'important';
          break;
        case 'PROCESSING':
          labelKind = 'important';
          break;
        case 'SHIPPED':
          labelKind = 'positive';
          break;
        case 'PLACED':
          labelKind = 'default';
          break;
      }
      return labelKind;
    },
  },
};
</script>
